<!-- prettier-ignore -->

@if(chatForm){
<div class="chat-input-wrapper">
  <!-- Hidden File Input -->
  <input #fileInput type="file" accept="image/*" style="display: none" (change)="onFileSelected($event)">

  <!-- Image Preview (for Query/Consultation) -->
  @if(dataChat.imagePreviewUrl()){
  <div class="image-preview-container">
    <img [src]="dataChat.imagePreviewUrl()" class="image-preview" alt="Preview">
    <button class="remove-image-btn" (click)="clearImage($event)" type="button">×</button>
  </div>
  }
  @else {
  <button type="button" class="upload-btn" (click)="fileInput.click()" [disabled]="isStreaming()"
    title="Consultar / ¿Qué es esto?">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <circle cx="12" cy="13" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  </button>
  }
  <!-- Camera Button (Query/Consultation) -->


  <div class="text-input-wrapper">
    <input 
      #inputChat 
      type="text" 
      [formControl]="getUserInputControl()" 
      [(ngModel)]="inputText"
      (keydown.enter)="emitKeyDownEvent($event)" 
      (keyup)="onKeyPress()" 
      [readonly]="isStreaming()" 
    />

    @if (!isStreaming() && !inputChat.value){
      <span class="text-placeholder" [class.dnone]="">{{'Escribe un mensaje...' | translate}}</span>
    }

    @if (isStreaming()){
      <span class="fake-placeholder" [class.dnone]="">{{'Esperando respuesta...' | translate}}</span>
    }
  </div>

</div>

}